import styled from 'styled-components';
import {device} from '../../../styled/device';

export const StyledModalGuestRegistered = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  max-width: 392px;
  margin: 0 auto;
  width: 100%;
`;

export const Row = styled.div`
  display: flex;
  justify-content: center;

  .link {
    cursor: pointer;
    font-size: 16px;
    font-weight: 500;
    color: #23262f;
    height: auto;

    &:hover {
      opacity: 0.7;
    }
  }
`;

export const ModalHeader = styled.div`
  display: flex;
  flex-direction: column;
  text-align: center;

  .modalTitle {
    display: flex;
    align-items: center;
    gap: 10px;
    font-size: 30px;
    font-weight: 400;
    color: #23262f;
    padding: 20px;
  }

  @media (max-width: ${device.mobileL}) {
    & .modalTitle {
      gap: 0;
    }
  }
`;

export const ModalTitleText = styled.div`
  margin: 0;
  white-space: nowrap;
  font-size: inherit;
  font-family: Poppins, sans-serif;

  @media (max-width: ${device.mobileL}) {
    white-space: normal;
    padding-right: 15px;
  }
`;

export const ModalSubtitle = styled.div`
  font-family: Poppins-Regular, sans-serif;
  font-size: 14px;
  color: #777e90;

  b {
    color: #353945;
  }
`;

export const ModalBody = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  padding-bottom: 30px;
`;
